import { Modal } from "react-bootstrap";
import styled from "styled-components";

export const StyledModalTitle = styled(Modal.Title)`
  font-size: 1.25rem;
  color: white !important;
`;
